export class PauseableTimer {
	private start: Date;
	private remaining: number;
	private durationTimeoutId?: ReturnType<typeof setTimeout>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	private callback: (...args: Array<any>) => void;
	private done: boolean = false;

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	constructor(callback: (...args: Array<any>) => void, ms: number = 0) {
		this.callback = () => {
			callback();
			this.done = true;
		};
		this.remaining = ms;
		this.resume();
	}

	public pause(): void {
		if (this.durationTimeoutId && !this.done) {
			this.clearTimeoutRef();
			this.remaining -= new Date().getTime() - this.start.getTime();
		}
	}

	public resume(): void {
		if (!this.durationTimeoutId && !this.done) {
			this.start = new Date();
			this.durationTimeoutId = setTimeout(this.callback, this.remaining);
		}
	}

	public clearTimeout(): void {
		this.clearTimeoutRef();
		this.done = true;
	}

	private clearTimeoutRef(): void {
		if (this.durationTimeoutId) {
			clearTimeout(this.durationTimeoutId);
			this.durationTimeoutId = undefined;
		}
	}

}